export const months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre'
];

export const excelHeaders = [
  {
    label: 'number',
    key: 'number'
  },
  {
    label: 'type',
    key: 'type'
  },
  {
    label: 'date',
    key: 'dateEffet'
  },
  {
    label: 'last_name',
    key: 'clientLastName'
  },
  {
    label: 'first_name',
    key: 'clientFirstName'
  },
  {
    label: 'fraction',
    key: 'fraction'
  },
  {
    label: 'user',
    key: 'user'
  },
  {
    label: 'resiliationDate',
    key: 'resiliationDate'
  },
  {
    label: 'address',
    key: 'address'
  },
  {
    label: 'status',
    key: 'status'
  },
  {
    label: 'brokerFee',
    key: 'brokerFee'
  },
  {
    label: 'commission_fee',
    key: 'commission_fee'
  },
  {
    label: 'contribution_adjustment',
    key: 'contribution_adjustment'
  },
  {
    label: 'pwf',
    key: 'pwf'
  },
  {
    label: 'cotiPaye',
    key: 'cotiPaye'
  },
  {
    label: 'cotiNonPaye',
    key: 'cotiNonPaye'
  },
  {
    label: 'unpaid_fee',
    key: 'unpaid_fees'
  },
  {
    label: 'commissions',
    key: 'commissions'
  }
];

export const excelMonthlyHeaders = [
  {
    label: 'number',
    key: 'number'
  },
  {
    label: 'type',
    key: 'type'
  },
  {
    label: 'date',
    key: 'effective_date'
  },
  {
    label: 'last_name',
    key: 'last_name'
  },
  {
    label: 'first_name',
    key: 'first_name'
  },
  {
    label: 'fraction',
    key: 'fraction_type'
  },
  {
    label: 'termination_date',
    key: 'termination_date'
  },
  {
    label: 'address',
    key: 'address'
  },
  {
    label: 'status',
    key: 'status'
  },
  {
    label: 'brokerFee',
    key: 'brokerFee'
  },
  {
    label: 'commission_fee',
    key: 'commission_fee'
  },
  {
    label: 'contribution_adjustment',
    key: 'contribution_adjustment'
  },
  {
    label: 'paperwork_fee',
    key: 'paperwork_fee'
  },
  {
    label: 'remuneration',
    key: 'remuneration'
  },
  {
    label: 'siret_number',
    key: 'siret_number'
  }
];
